import { render } from "./SelectLanguage.vue?vue&type=template&id=e8e12c5e&scoped=true"
import script from "./SelectLanguage.vue?vue&type=script&lang=js"
export * from "./SelectLanguage.vue?vue&type=script&lang=js"

import "@/assets/scss/_selectLanguage.scss?vue&type=style&index=0&id=e8e12c5e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8e12c5e"]])

export default __exports__